<script setup>
import { reactive } from 'vue';

import { store, toggleCorrectNavigationOption } from '@/store';
import { getUserByUid } from "../firebase_files/user_functions"
import { uid } from "../firebase_files/login"

import PhysicianCard from './PhysicianCard.vue';
import UploadModal from './UploadModal.vue';
import SpinnerWheel from '@/components/SpinnerWheel.vue';


const state = reactive({
  openModal: false,
  modalDoctor: null,
  modalType: null,
  physicians: null,
});

init();
async function init(){
  toggleCorrectNavigationOption()
  let userObject = await getUserByUid(uid);
  const physicians = userObject.physicians;
  state.physicians = physicians.map((d) => {
    return { 
      name: d.name, 
      uid:d.uid,
      cpso:d.cpso,
      department: d.department,
      hospital: d.hospital,
    };
  });
}

function openModal(doctor, type) {
  state.openModal = true;
  state.modalDoctor = doctor;
  state.modalType = type;
}
// TODO: close modal
function closeModal() {
  state.openModal = false;
  state.modalDoctor = null;
  state.modalType = null; 
  // recall firebase for physicians
}

</script>
<template>
  <div id="title">
    <h1>Secretary Dashboard</h1>
  </div>

  <div class="content-box">
    <div class="row-entry header">
      <h3 class="name">Physician Name</h3>
      <h3 class="completed">Schedule Status</h3>
    </div>
    <PhysicianCard v-if="state.physicians" class="row-entry" v-for="physician in state.physicians" :key="physician.name" 
    :doctor="physician" @openModal="(doc, type)=> openModal(doc, type)" />
    <SpinnerWheel v-else/>
  </div>


  <UploadModal v-if="state.openModal && !store.aptDone" :doctor="state.modalDoctor" :type="state.modalType" 
  @close="closeModal"
  />

</template>
<style scoped lang="scss">
#title {
  text-align: center;
  background-color: #fff;
  border-radius: 1rem;
  margin: 1rem 0;
  border: 1px solid #ccc;
  border-top: 5px solid #673ab7;
}

.row-entry {
  display: flex;

  .name {
    flex: 6;
    text-align: center;
  }

  .completed {
    flex: 4;
    text-align: center;
  }
}


.header {
  font-weight: bold;
  border-bottom: solid 2px #aaa;
  // padding: 0.5rem 0;
}
</style>